export default __webpack_public_path__ + "static/media/file-solid-full-red.c7d4fbf4.svg";